import * as React from 'react';
import {WithStyles, MenuItem, ListItemIcon, withStyles, } from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { HeaderStyle } from './Header.style';
import HistoryIcon from '@material-ui/icons/History';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import DeleteIcon from '@material-ui/icons/DeleteForeverRounded';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import { SUGGESTION_CHANGE_TYPES, SUGGESTION_TYPES } from '@constants/suggestionTypes';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { grayColor, primaryColor } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof HeaderStyle> {
  userId:number;
  family:IFamilyMember[];  
  suggestion:ISuggestion;

  close:() => void;
  startEditing:(scheduleId:number, suggestionId:number|undefined) => void;
  showDetails:(suggestion:ISuggestion) => void;
}

class SuggestionItem extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }



  public render() {
    const {classes,  startEditing, userId, family, suggestion} = this.props;

    const person = family.find((mem) =>mem.id === suggestion.creatorId);
    let icon:JSX.Element = person
      ?<ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
        imgName={person.avatar} style={{width:'20px', height:'20px'}} color={person.color} />
      :<HistoryIcon fontSize="small" />;

    let plupp:JSX.Element = <span />;
    let title:string = tn.lang.calSuggestionFrom(
      tn.familyMemberName(suggestion.creatorId,family), tn.formatMonthDate(new Date(suggestion.publishTime)));
    if (suggestion.changes.length === 1 && suggestion.changes[0].type === SUGGESTION_CHANGE_TYPES.DELETE_SCHEDULE) {
      title = tn.lang.calSuggestionErase;
    }
    let subTitle:string = "";

    tn.familyMemberName(suggestion.creatorId, family)

    let isHistory:boolean = true;
    let scheduleId:number = 0;
    let suggestionId:number|undefined;
    const subStyle:React.CSSProperties = {};
    const titleStyle:React.CSSProperties = {};
    if (suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL) {
      isHistory = false;
      if (suggestion.creatorId === userId) {
        subStyle.textShadow = '0 0 10px '+grayColor;
        subTitle = tn.lang.calSuggestionAwaitReply;
        plupp = <span style={{backgroundColor:grayColor, marginLeft: '8px'}} className={classes.suggestionBadge} />;
      } else {
        subStyle.textShadow = '0 0 10px '+primaryColor;
        titleStyle.fontWeight = 500;
        subTitle = tn.lang.calSuggestionAwaitReplyFYou;
        plupp = <span style={{backgroundColor:primaryColor, marginLeft: '8px'}} className={classes.suggestionBadge} />;
      }

      suggestionId = suggestion.id;
      scheduleId = (suggestion.schedules && suggestion.schedules.length > 0)? suggestion.schedules[0]:0;
    } else if (suggestion.status === SUGGESTION_TYPES.ACCEPTED_AND_EXECUTED) {
      isHistory = true;
      icon = <ThumbUpIcon fontSize='small' style={{fill:'#93A37C'}} />
      subTitle = tn.lang.calSuggestionSubAccepted(tn.familyMemberName(suggestion.responseAccountId, family),
        tn.formatMonthDate(new Date(suggestion.responseTime)));
    } else if (suggestion.status === SUGGESTION_TYPES.DELETED 
      || (suggestion.status === SUGGESTION_TYPES.REJECTED && suggestion.creatorId === suggestion.responseAccountId)) {
      isHistory = true;
      icon = <DeleteIcon fontSize='small' />
      subTitle = tn.lang.calSuggestionSubDeleted(tn.familyMemberName(suggestion.responseAccountId, family),
        tn.formatMonthDate(new Date(suggestion.responseTime)));
    } else if (suggestion.status === SUGGESTION_TYPES.REJECTED) {
      isHistory = true;
      icon = <ThumbDownIcon fontSize='small' style={{fill:'#D96159'}} />
      subTitle = tn.lang.calSuggestionSubRejected(tn.familyMemberName(suggestion.responseAccountId, family),
        tn.formatMonthDate(new Date(suggestion.responseTime)));
    } 

    return (
      <MenuItem
        className={classes.menuListItem}
        key={suggestion.id}
        onClick={() => { 
          if (isHistory) {
            this.props.showDetails(suggestion);
          } else {
            startEditing(scheduleId,suggestionId);
          }
          this.props.close();
        }}>
        <ListItemIcon>
          {icon}
          {plupp}
        </ListItemIcon>
        <div>
          <div className={classes.menuItemTitle} style={titleStyle}>{title}</div>
          <div className={classes.menuItemTime} style={subStyle}>{subTitle}</div>
        </div>
      </MenuItem>);
  }

}

export default withStyles(HeaderStyle)(SuggestionItem);



// WEBPACK FOOTER //
// ./src/components/calendar2/header/SuggestionItem.tsx